import React from 'react'
import Link from 'next/link'
import Image from 'next/image'
import { CustomTitle } from 'src/components'
import { PlusIcon } from 'src/assets/images'
import { useTranslation } from 'next-i18next'
import styles from './EmptyProjectCard.module.scss'

const EmptyProjectCard: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Link href={'/my-projects/create'} passHref legacyBehavior>
      <a>
        <div className={styles.card}>
          <div className={styles.content}>
            <Image width={37} height={37} src={PlusIcon} alt={'plus-icon'} />
            <CustomTitle level={4} label={t('Projects.List.Create')} />
          </div>
        </div>
      </a>
    </Link>
  )
}

export default EmptyProjectCard
